import { MasterOfActsAPI } from "../../api/api";
import {downloadFile} from "../../utils/files";

const SUCCESS_LOAD_CONTRACTOR_ACTS = "contractorActReducer/SUCCESS_LOAD_CONTRACTOR_ACTS";
const FETCH_CONTRACTOR_ACTS = "contractorActReducer/FETCH_CONTRACTOR_ACTS";
const ERROR_LOAD_CONTRACTOR_ACTS = "contractorActReducer/ERROR_LOAD_CONTRACTOR_ACTS";
const SET_SELECTED_CONTRACTOR_ACTS = "contractorActReducer/SET_SELECTED_CONTRACTOR_ACTS";


const initialState = {
  contractorActs: [],
  selectedContractorAct: null,
  loading: true,
  error: null,
};

export const contractorActReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_LOAD_CONTRACTOR_ACTS:
      return {
        ...state,
        contractorActs: action.contractorActs,
        loading: false,
      };  
    case FETCH_CONTRACTOR_ACTS:
      return {
        ...state,
        loading: true,
      };
    case ERROR_LOAD_CONTRACTOR_ACTS:
      return {
        ...state,
        loading: false,
        error: "Что-то пошло не так... Попробуйте перезагрузить страницу",
      };
    case SET_SELECTED_CONTRACTOR_ACTS:
      return {
        ...state,
        selectedContractorAct: action.selectedContractorAct,
        loading: false,
      };
    default:
      return state;
  }
};

export const selectContractorAct = (state) => state.contractorActReducer;

export const successLoadContractorActs = (contractorActs) => ({
  type: SUCCESS_LOAD_CONTRACTOR_ACTS,
  contractorActs,
});

export const fetchContractorActs = () => ({ type: FETCH_CONTRACTOR_ACTS });
export const errorLoadContractorActs = () => ({ type: ERROR_LOAD_CONTRACTOR_ACTS });
export const setSelectedContractorAct = (selectedContractorAct) => ({
  type: SET_SELECTED_CONTRACTOR_ACTS    ,
  selectedContractorAct,
});


export const downloadContractorRemovalFile = async (fileId) => {
  await downloadFile(MasterOfActsAPI.downloadContractorRemovalFile(fileId))
}

export const loadingContractorActs =
    (organization) => async (dispatch) => {
      dispatch(fetchContractorActs());
      
      const response = await MasterOfActsAPI.getContractorActs(
        organization 
      );

      if (response.status === 200 && response.data.length !== 0) {
        dispatch(successLoadContractorActs(response.data));
      } else {
        dispatch(errorLoadContractorActs());
      }
    };